module.exports={
  "Description": "MS : MSR NNNN",
  "RedundantCharacters": " -",
  "ValidationRegex": "^(MSR)?[0-9]{4}$",
  "TestData": {
    "Valid": [
      "MSR 1110",
      "MSR 1350",
	  "1350"
    ],
    "Invalid": [
      "MS1110",
      "MSR01350",
	  "12345"
    ]
  }
}